<abc-accordion
  class="accordion-style container"
  [collapsible]="true"
  [selectedIndex]="-1"
  [width]="'100%'"
  [animationDuration]="300"
  [visible]="true"
  [multiple]="false"
  [dataSource]="['Test']"
>
  <div *dxTemplate="let company of 'title'" class="dx-accordion-item-title">
    {{ this.dataService.res("Ubt-MeasureDetail-Status-Report") }}
  </div>

  <div
    fxLayout="column"
    class="card-paddings container-card"
    *dxTemplate="let company of 'item'"
  >
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
      <div fxLayoutAlign="start">
        <ng-container>
          <div fxLayout="row">
            <img class="date-start-style" src="assets/images/dateStart.svg" />
            @if (lastMeasureProgress.ProgressDate) {
              <div>
                {{
                  convertHelper.toLocaleFormattedDateString(
                    lastMeasureProgress?.ProgressDate?.toString()
                  )
                }}
                {{
                  lastMeasureProgress["Properties"]
                    ? lastMeasureProgress["Properties"][0]["Designation"]
                    : ""
                }}
              </div>
            }
            @if (!lastMeasureProgress.ProgressDate) {
              <div>
                {{ convertHelper.toLocaleFormattedDateString(date) }}
              </div>
            }
          </div>
        </ng-container>
      </div>
      <div fxLayoutAlign="end">
        <abc-check-box
          class="check-box-style"
          [(value)]="workOnLastStatus"
          [height]="'100%'"
          [width]="'100%'"
          [disabled]="
            isNewMeasureTask ||
            measureProgress?.length === 0 ||
            !canManageStatusReport
          "
          text="{{ dataService.res('Ubt-MeasureDetail-Duplicate-Content') }}"
        >
        </abc-check-box>
        <div>
          <abc-button
            [stylingMode]="'text'"
            [icon]="'assets/images/plus.svg'"
            [type]="'normal'"
            [hint]="dataService.res('Ubt-MeasureDetail-New-Status')"
            (onClick)="clearProgressFileds()"
            [disabled]="
              isNewMeasureTask ||
              measureProgress.length === 0 ||
              !canManageStatusReport
            "
            [height]="'100%'"
          >
          </abc-button>
        </div>

        <abc-button
          [stylingMode]="'text'"
          [icon]="'assets/images/Delete.svg'"
          [type]="'normal'"
          [hint]="dataService.res('Ubt-MeasureDetail-Delete')"
          class="assgin-progress-button"
          (onClick)="openConfirmTaskDialog()"
          [disabled]="
            measureProgress.length == 0 ||
            !lastMeasureProgress.Id ||
            IsRoleAuthorizedToUpdate()
          "
          [height]="'100%'"
        >
        </abc-button>
        <abc-button
          [stylingMode]="'text'"
          [icon]="'assets/images/save.svg'"
          [type]="'normal'"
          class="assgin-progress-button"
          [hint]="dataService.res('Ubt-MeasureDetail-Save')"
          [height]="'100%'"
          (onClick)="persistStatusReport()"
          [disabled]="disableSave || !canManageStatusReport"
        >
        </abc-button>
        <abc-button
          stylingMode="text"
          [icon]="'assets/images/navigate_left.svg'"
          type="default"
          class="assgin-progress-button"
          [hint]="dataService.res('Ubt-Navigation-Previous')"
          [disabled]="
            this.appService.currentMeasureProgressIndex() === 0 ||
            appService.currentMeasureProgressIndex() === -1 ||
            measureProgress.length === 1 ||
            measureProgress.length === 0 ||
            isNewMeasureTask
          "
          (onClick)="navigateToMeasureProgress(-1)"
          [hoverStateEnabled]="false"
        >
        </abc-button>
        <abc-button
          stylingMode="text"
          [icon]="'assets/images/navigate_right.svg'"
          type="default"
          class="assgin-progress-button"
          [hint]="dataService.res('Ubt-Navigation-Next')"
          [disabled]="
            this.appService.currentMeasureProgressIndex() ===
              measureProgress?.length - 1 ||
            this.appService.currentMeasureProgressIndex() === -1 ||
            measureProgress.length === 1 ||
            measureProgress.length === 0 ||
            isNewMeasureTask
          "
          (onClick)="navigateToMeasureProgress(1)"
          [hoverStateEnabled]="false"
        >
        </abc-button>
      </div>
    </div>
    <div fxLayout="row">
      <div fxFlex="50" fxLayout="column">
        <div fxLayout="row" fxLayoutAlign="space-between">
          <span class="html-editor-title-style">{{
            dataService.res("Ubt-MeasureDetail-Progress")
          }}</span>
          <span
            fxLayout="row"
            class="dx-icon-edit edit-button-style"
            (click)="openPopup(lastMeasureProgress.Progress, 'Progress')"
          ></span>
        </div>
        <dx-html-editor
          fxLayout="row"
          height="200px"
          class="background-white"
          [(value)]="lastMeasureProgress.Progress"
          (onFocusIn)="focusIn(lastMeasureProgress.Progress)"
          [disabled]="IsRoleAuthorizedToUpdate()"
          (onValueChanged)="
            verifyChanges($event, lastMeasureProgress.Progress, 'Progress')
          "
        >
        </dx-html-editor>
      </div>
      <div fxFlex="50" fxLayout="column">
        <div fxLayout="row" fxLayoutAlign="space-between">
          <span class="html-editor-title-style">{{
            dataService.res("Ubt-MeasureDetail-Next-Steps")
          }}</span>
          <span
            fxLayout="row"
            class="dx-icon-edit edit-button-style"
            (click)="openPopup(lastMeasureProgress.NextSteps, 'NextSteps')"
          ></span>
        </div>

        <dx-html-editor
          fxLayout="row"
          height="200px"
          class="background-white"
          [(value)]="lastMeasureProgress.NextSteps"
          (onFocusIn)="focusIn(lastMeasureProgress.NextSteps)"
          [disabled]="IsRoleAuthorizedToUpdate()"
          (onValueChanged)="
            verifyChanges($event, lastMeasureProgress.NextSteps, 'NextSteps')
          "
        >
        </dx-html-editor>
      </div>
    </div>
    <div fxLayout="row">
      <div fxFlex="50" fxLayout="column">
        <div fxLayout="row" fxLayoutAlign="space-between">
          <span class="html-editor-title-style">{{
            dataService.res("Ubt-MeasureDetail-Risks-Opportunities")
          }}</span>
          <span
            fxLayout="row"
            class="dx-icon-edit edit-button-style"
            (click)="
              openPopup(lastMeasureProgress.RiskAndChance, 'RiskAndChance')
            "
          ></span>
        </div>

        <dx-html-editor
          fxLayout="row"
          height="200px"
          class="background-white"
          [(value)]="lastMeasureProgress.RiskAndChance"
          (onFocusIn)="focusIn(lastMeasureProgress.RiskAndChance)"
          [disabled]="IsRoleAuthorizedToUpdate()"
          (onValueChanged)="
            verifyChanges(
              $event,
              lastMeasureProgress.RiskAndChance,
              'RiskAndChance'
            )
          "
        >
        </dx-html-editor>
      </div>
      <div fxFlex="50" fxLayout="column">
        <div fxLayout="row" fxLayoutAlign="space-between">
          <span class="html-editor-title-style">{{
            dataService.res("Ubt-MeasureDetail-Decision-Clarification")
          }}</span>
          <span
            fxLayout="row"
            class="dx-icon-edit edit-button-style"
            (click)="openPopup(lastMeasureProgress.Decision, 'Decision')"
          ></span>
        </div>

        <dx-html-editor
          fxLayout="row"
          height="200px"
          class="background-white"
          [(value)]="lastMeasureProgress.Decision"
          (onFocusIn)="focusIn(lastMeasureProgress.Decision)"
          [disabled]="IsRoleAuthorizedToUpdate()"
          (onValueChanged)="
            verifyChanges($event, lastMeasureProgress.Decision, 'Decision')
          "
        >
        </dx-html-editor>
      </div>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
      <div fxFlex="33">
        <abc-number-box
          #progressField
          [(value)]="lastMeasureProgress.ProgressPercentage"
          [min]="0"
          [max]="100"
          [stylingMode]="'outlined'"
          [format]="dataService.customizePercentageText"
          [label]="dataService.res('Ubt-MeasureDetail-Chart-Progress')"
          [labelMode]="'floating'"
          [disabled]="IsRoleAuthorizedToUpdate()"
          (onValueChanged)="verifyChanges($event, 'ProgressPercentage')"
        >
        </abc-number-box>
      </div>
    </div>
  </div>
</abc-accordion>

<abc-popup
  #confirmDeletePopup
  [width]="'25%'"
  [maxHeight]="'90vh'"
  [minWidth]="'250px'"
  fxLayout="column"
  fxLayoutAlign="center center"
  [height]="'auto'"
  [title]="dataService.res('Ubt-MeasureList-Confirm-Delete')"
  [showCloseButton]="true"
>
  <div
    class="dx-card popup-card-paddings card-radius"
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayoutGap="20px"
  >
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px">
      {{ dataService.res("Ubt-MeasureList-Delete-Message") }}
    </div>

    <dxi-item
      itemType="group"
      fxLayout="row"
      fxLayoutAlign="end end"
      fxLayoutGap="20px"
    >
      <abc-button
        class="submit-button"
        [text]="dataService.res('Ubt-Company-Icon-Delete')"
        [text]="dataService.res('Ubt-MeasureList-Yes')"
        (onClick)="deleteStatusReport()"
      >
      </abc-button>
      <abc-button
        class="cancel-button"
        [text]="dataService.res('Ubt-MeasureList-No')"
        (onClick)="abortTaskDelete()"
      >
      </abc-button>
    </dxi-item>
  </div>
</abc-popup>

<abc-popup
  [height]="'auto'"
  [maxHeight]="'90vh'"
  [width]="'95%'"
  [maxWidth]="'1000px'"
  [(visible)]="toogleTitleVisible"
  [resizeEnabled]="true"
  title="{{ dataService.res('Ubt-Measure-Detail-Html-Editor-Title') }}"
  [showCloseButton]="true"
>
  <div
    class="dx-card popup-card-paddings card-radius"
    fxLayout="column"
    fxLayoutGap="10px"
  >
    <div fxLayout="row" fxLayoutAlign="space-between center" class="header-row">
      <div fxFlex="grow">
        {{ dataService.res("Ubt-Html-Editor-" + propertyName) }}
      </div>
      <div fxFlex="none">
        <abc-button
          class="edit-text"
          type="default"
          [icon]="'save'"
          [hint]="'Save'"
          [disabled]="IsRoleAuthorizedToUpdate()"
          (onClick)="saveChanges(propertyName, fieldValue)"
        >
        </abc-button>
      </div>
    </div>

    <div fxLayout="row" fxFlex="grow">
      <dx-html-editor
        #htmlEditor
        [height]="getEditorHeight()"
        [width]="'100%'"
        (onValueChanged)="verifyChanges($event, fieldValue)"
        [(value)]="fieldValue"
        [disabled]="IsRoleAuthorizedToUpdate()"
        class="html-editor-style"
      >
        <dxo-toolbar [multiline]="false">
          <dxi-item name="undo"></dxi-item>
          <dxi-item name="redo"></dxi-item>
          <dxi-item name="separator"></dxi-item>
          <dxi-item name="color"></dxi-item>
          <dxi-item name="separator"></dxi-item>
          <dxi-item name="bold"></dxi-item>
          <dxi-item name="italic"></dxi-item>
          <dxi-item name="strike"></dxi-item>
          <dxi-item name="underline"></dxi-item>
          <dxi-item name="separator"></dxi-item>
          <dxi-item name="alignLeft"></dxi-item>
          <dxi-item name="alignCenter"></dxi-item>
          <dxi-item name="alignRight"></dxi-item>
          <dxi-item name="alignJustify"></dxi-item>
          <dxi-item name="separator"></dxi-item>
          <dxi-item name="orderedList"></dxi-item>
          <dxi-item name="bulletList"></dxi-item>
          <dxi-item name="separator"></dxi-item>
          <dxi-item name="insertTable"></dxi-item>
          <dxi-item name="deleteTable"></dxi-item>
          <dxi-item name="insertRowBelow"></dxi-item>
        </dxo-toolbar>
      </dx-html-editor>
    </div>
  </div>
</abc-popup>
